import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import { useLoading } from "../../../../util/LoadingProvider";
import EmailTemplateSubmissionForm from "./EmailTemplateSubmissionForm";

const defaultFormValues = {
  contentEN_approve: "",
  contentTC_approve: "",
  contentEN_decline: "",
  contentTC_decline: "",
  contentEN_voucher: "",
  contentTC_voucher: "",
};

const useStyles = makeStyles((theme) => ({
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "362px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: "20px 30px 10px",
    background: "#ffffff",
    minHeight: "800px",
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

export default function RefundEmailSettingsPage({ disabled, ...props }) {
  const [defaultValues] = useState(defaultFormValues);
  const [initialValues, setInitialValues] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { setLoading } = useLoading();

  const classes = useStyles();

  const {
    control,
    handleSubmit,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const onSubmit = (value) => {
    updateRefundEmailSettings(value);
  };

  const getRefundEmailSettings = async () => {
    setLoading(true);
    try {
      const result = await apiHelper.hkiff.getRefundEmailSettings();
      console.log(result);
      setInitialValues({
        contentEN_approve: result.data[0].contentEN,
        contentTC_approve: result.data[0].contentTC,
        contentEN_decline: result.data[1].contentEN,
        contentTC_decline: result.data[1].contentTC,
        contentEN_voucher: result.data[3].contentEN,
        contentTC_voucher: result.data[3].contentTC,
        contentEN_acknowledge: result.data[2].contentEN,
        contentTC_acknowledge: result.data[2].contentTC,
      });
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getRefundEmailSettings();
  }, []);

  const updateRefundEmailSettings = async (value) => {
    try {
      let req = {}
      switch(activeTab){
        case 0:
          req = {
            contentEN: value.contentEN_approve,
            contentTC: value.contentTC_approve,
            type: "refund_status_approve",
          }
          break;
        case 1:
          req = {
            contentEN: value.contentEN_decline,
            contentTC: value.contentTC_decline,
            type: "refund_status_decline",
          }
          break;
        case 2:
          req = {
            contentEN: value.contentEN_voucher,
            contentTC: value.contentTC_voucher,
            type: "refund_status_voucher",
          }
          break;
        case 3:
            req = {
              contentEN: value.contentEN_acknowledge,
              contentTC: value.contentTC_acknowledge,
              type: "refund_acknowledge",
            }
            break;
        default:
          break;
      }

      const result = await apiHelper.hkiff.updateRefundEmailSettings(req);
      console.log(result);
      if (result.data.code === 0) {
        await getRefundEmailSettings();
        toast.dark("Your changes is saved.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className={classes.content}>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Refund &gt; Email Content Setting
        </Typography>
      </Box>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab label="Success" {...a11yProps(0)} />
        <Tab label="Failure" {...a11yProps(1)} />
        <Tab label="Voucher" {...a11yProps(2)} />
        <Tab label="Acknowledge" {...a11yProps(3)} />
      </Tabs>
      {initialValues && (
          <>
            <TabPanel value={activeTab} index={0}>
              <EmailTemplateSubmissionForm
                type="Success"
                suffix="approve"
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                control={control}
                classes={classes}
                disabled={disabled}
              />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
              <EmailTemplateSubmissionForm
                type="Failure"
                suffix="decline"
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                control={control}
                classes={classes}
                disabled={disabled}
              />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              <EmailTemplateSubmissionForm
                type="Voucher"
                suffix="voucher"
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                control={control}
                classes={classes}
                disabled={disabled}
              />
            </TabPanel>
            <TabPanel value={activeTab} index={3}>
              <EmailTemplateSubmissionForm
                type="Acknowledge"
                suffix="acknowledge"
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                control={control}
                classes={classes}
                disabled={disabled}
              />
            </TabPanel>
          </>
        )}
    </div>
  );
}
